import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Validators, FormBuilder } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
var Profesional_compComponent = /** @class */ (function () {
    function Profesional_compComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.matcher = new FormService();
        this.selectedProC = null;
        this.rut_rep = this.fb.group({
            rut: ['', [Validators.required, rutValidator]]
        });
        if (!JSON.parse(localStorage.getItem("profesionalComp"))) {
            localStorage.setItem("profesionalComp", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("profesionalComp"));
            console.log(this.rows);
        }
        this.invalidRut = true;
        this.profesional_comp = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
    }
    Profesional_compComponent.prototype.get_profesional_comp = function (rut) {
        var _this = this;
        this.spinner.show();
        this._userService.getprofesional_comp(rut).subscribe(function (response) {
            _this.spinner.hide();
            if (response.message) {
                _this.profesional_comp.rut = rut ? rut : '';
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.profesional_comp.rut = response.rut ? response.rut : '';
                _this.profesional_comp.nombre = response.nombre ? response.nombre : '';
                _this.profesional_comp.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                _this.profesional_comp.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                _this.profesional_comp.direccion = response.direccion ? response.direccion : '';
                _this.profesional_comp.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.profesional_comp.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.profesional_comp.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.profesional_comp.comuna = response.comuna ? response.comuna : '';
                _this.profesional_comp.fono = response.fono ? response.fono : '';
                _this.profesional_comp.mail = response.mail ? response.mail : '';
                _this.profesional_comp.recordId = response.recordId ? response.recordId : '';
                _this.dialog.open(_this.openModal);
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    Profesional_compComponent.prototype.cleanData = function () {
        this.profesional_comp = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
        this.rut_rep.reset();
    };
    Profesional_compComponent.prototype.update_profesional_comp = function (rut, id) {
        this.get_profesional_comp(rut);
        this.selectedProC = id;
    };
    Profesional_compComponent.prototype.saveprofesional_comp = function () {
        var _this = this;
        window.scroll(0, 0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (var x = 0; x < this.rows.length; x++) {
            if (this.profesional_comp.rut == this.rows[x].rut) {
                this.delete_profesional_comp(x);
            }
        }
        //elimina fila cuando la editan
        /*if (this.selectedProC != null) {
            this.delete_profesional_comp(this.selectedProC);
            this.selectedProC = null;
        }*/
        this.spinner.show();
        this._userService.saveprofesional_comp(this.profesional_comp).subscribe(function (response) {
            _this.spinner.hide();
            console.log(response);
            if (response.update || response.save) {
                $("#rep_modal").modal("hide");
                _this.actualRow = localStorage.getItem("profesionalComp");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.profesional_comp.rut,
                    nombre: _this.profesional_comp.nombre,
                    apellido_pat: _this.profesional_comp.apellido_pat,
                    apellido_mat: _this.profesional_comp.apellido_mat,
                    direccion: _this.profesional_comp.direccion,
                    direccion_num: _this.profesional_comp.direccion_num,
                    direccion_complemento: _this.profesional_comp.direccion_complemento,
                    direccion_completa: _this.profesional_comp.direccion_completa,
                    comuna: _this.profesional_comp.comuna,
                    fono: _this.profesional_comp.fono,
                    mail: _this.profesional_comp.mail
                });
                localStorage.setItem("profesionalComp", JSON.stringify(_this.rows));
                _this.profesional_comp = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
                _this.rut_rep.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    Profesional_compComponent.prototype.delete_profesional_comp = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("profesionalComp", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('profesionalComp'));
            }
        }
    };
    return Profesional_compComponent;
}());
export { Profesional_compComponent };
